import template from './movements.html';
import controller from './movements.controller';

const dashboardMovementsComponent = {
  restrict: 'E',
  bindings: {
    condensed: '@'
  },
  controller,
  template
};

export default dashboardMovementsComponent;



/** WEBPACK FOOTER **
 ** ./client/app/components/dashboard/movements/movements.component.js
 **/